import { useState, useEffect, lazy, Suspense } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import { useAuth } from "../Common/Configurations/AuthContext";
import { HomePageSlider } from "./HomePageSlider";
const initialLoginValues = { username: "", password: "" };
export default function Login() {
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [values, setValues] = useState(initialLoginValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [apiError, setApiError] = useState("");

  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    // Clear API error when user starts typing
    if (apiError) setApiError("");
  };

  // fix validation bug
  const validate = () => {
    let temp = {};
    temp.username = values.username !== "";
    temp.password = values.password !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const userEmail = location.state?.userEmail;

  // fix infinite loop with dependency
  useEffect(() => {
    let host = window.location.hostname;
    if (host.startsWith("www.")) host = host.replace("www.", "");
    if (host.startsWith("admin.")) host = host.replace("admin.", "");
    if (host.startsWith("app.")) host = host.replace("app.", "");
    const tenant = host.split(".")[0];
    const allowedTenants = ["localhost", "trawtel", "zotrai"];
    setShow(allowedTenants.includes(tenant));
    localStorage.setItem("tenant", tenant === "localhost" ? "trawtel" : tenant);
  }, []);

  // form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(""); // Clear previous errors

    if (validate()) {
      setBtnSubmit(true);
      const formData = {
        username: values.username,
        password: values.password,
        tenant: localStorage.getItem("tenant"),
      };
      try {
        const result = await apiService.post(config.LOGIN, formData);
        // Check if registration is pending (user or company inactive but GST exists)
        if (result.registrationPending) {
          navigate("/registration-pending", {
            state: {
              userEmail,
              message: result.message,
            },
          });
          return;
        }

        // Normal login flow
        login({
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        });
      } catch (error) {
        console.error("Login failed:", error);

        // Handle registration pending from error response
        if (error.response?.data?.registrationPending) {
          navigate("/registration-pending", {
            state: {
              userEmail,
              message: error.response.data.message,
            },
          });
          return;
        }

        setApiError(
          error.response?.data?.message || "Login failed. Please try again."
        );
      } finally {
        setBtnSubmit(false);
      }
    }
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" style={{ backgroundColor: "#4e90f4ff" }}></div>
      <div className="auth-page-content overflow-hidden mt-lg-4">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center ">
            <div className="col-lg-5 col-md-6 col-sm-10">
              <div className="card overflow-hidden rounded-4 loginbox shadow">
                <div className="p-lg-5 p-4">
                  <h3 className="text-center">TRAVEL CRM</h3>
                  <p className="text-muted text-center">Only for staff</p>
                  <p className="text-muted text-center">Sign in to continue...</p>
                  <form
                    onSubmit={handleSubmit}
                    autoComplete="off"
                    noValidate
                  >
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        Username
                      </label>
                      <input
                        className={
                          "form-control" + applyErrorClass("username")
                        }
                        name="username"
                        type="text"
                        value={values.username}
                        onChange={handleInputChange}
                        placeholder="Enter Username"
                      />
                      {errors.username === false && (
                        <div className="validationerror">
                          Please enter username
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="password-input"
                      >
                        Password
                      </label>
                      <div className="position-relative auth-pass-inputgroup mb-1">
                        <input
                          className={
                            "form-control" + applyErrorClass("password")
                          }
                          name="password"
                          type={showPassword ? "text" : "password"}
                          value={values.password}
                          onChange={handleInputChange}
                          placeholder="Password"
                        />
                        <span
                          className="position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? (
                            <i className="ri-eye-line"></i>
                          ) : (
                            <i className="ri-eye-off-line"></i>
                          )}
                        </span>
                      </div>
                      {errors.password === false && (
                        <div className="validationerror">
                          Please enter password
                        </div>
                      )}
                    </div>
                    <div className="mt-4 d-flex justify-content-end">
                      {!btnSubmit ? (
                        <button
                          type="submit"
                          className="btn btn-success w-100 me-2"
                        >
                          Sign In
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary w-100 me-2"
                          disabled
                        >
                          Please wait...
                        </button>
                      )}
                      <Link to="/" className="btn btn-danger me-2 w-100">
                        Back
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
